// 自动生成的antd主题文件，不要自己编辑
export default {
  primaryColor: '#0082fc',
  infoColor: '#0082fc',
  successColor: '#00c82a',
  errorColor: '#ff3d23',
  warningColor: '#faad14',
  primaryWhite: 'white',
  primaryGrey: '#8496ab',
  primaryBlack: '#000',
  primaryLightGrey: '#eef3fa',
  textGrey: '#8097ad',
  textBlack: '#333'
};